import { gql, useMutation } from '@apollo/client';
import {
  UpdateCampaignMutation,
  UpdateCampaignMutationVariables,
} from '__generated__/queries-newsletter';
import { CAMPAIGN_FRAGMENT } from 'apollo/fragments/campaign.newsletter.graphql';
import { useCallback } from 'react';

export const UPDATE_CAMPAIGN_MUTATION = gql`
  mutation UpdateCampaign(
    $where: CampaignWhereUniqueInput!
    $data: CampaignUpdateInput!
  ) {
    updateCampaign(where: $where, data: $data) {
      ...Campaign
    }
  }
  ${CAMPAIGN_FRAGMENT}
`;

export const useUpdateCampaignLockerId = () => {
  const [updateCampaign] = useMutation<
    UpdateCampaignMutation,
    UpdateCampaignMutationVariables
  >(UPDATE_CAMPAIGN_MUTATION);

  return useCallback(
    (id: string, lockerId: string | null, noCacheUpdate?: boolean) =>
      updateCampaign({
        variables: {
          where: { id },
          data: { lockerId },
        },
        fetchPolicy: noCacheUpdate ? 'no-cache' : undefined,
      }),
    [updateCampaign],
  );
};
